import { useState, useEffect, useCallback } from "react";
import { logUserToMixpanel } from "../utils/mixpanel";
import Cookies from "js-cookie";

export function useAuthData(apiBaseUrl) {
  const [authToken, setAuthToken] = useState("");
  const [loggedInUser, setLoggedInUser] = useState({});
  const [trainingProgram, setTrainingProgram] = useState(null);
  const [allTrainingPrograms, setAllTrainingPrograms] = useState(null);

  // Helper to save token and clear user state
  const saveAuthToken = useCallback((token) => {
    const isSecure = window.location.protocol === "https:";
    Cookies.set("token", token, {
      expires: 7,
      secure: isSecure,
      sameSite: isSecure ? "None" : "Lax",
    });
    setAuthToken(token);
    setLoggedInUser({});
  }, []);

  // 1. Load Token on Mount
  useEffect(() => {
    const token = Cookies.get("token");
    if (token && token.length > 0) {
      setAuthToken(token);
    }
  }, []);

  const fetchUser = async () => {
    if (!authToken || !apiBaseUrl) return;

    const controller = new AbortController();
    const signal = controller.signal;

    try {
      const headers = { Authorization: `Token ${authToken}` };

      // Fetch User
      const userResponse = await fetch(`${apiBaseUrl}/user`, {
        headers,
        signal,
      });
      const userData = await userResponse.json();

      logUserToMixpanel(userData);

      if (Object.keys(userData).includes("email")) {
        setLoggedInUser(userData);
      } else {
        setLoggedInUser({});
        saveAuthToken("");
        return; // Stop if auth invalid
      }

      // COMMENT BACK IN IF ALL PROGRAMS NEEDED
      // Fetch Programs (Parallel) COMMENTED OUT AS ONLY SUBSCRIBED IS CURRENTLY NEEDED
      // const [allProgramsRes, subscribedRes] = await Promise.all([
      //    fetch(`${apiBaseUrl}/trainingprograms`, { headers, signal }),
      //   fetch(`${apiBaseUrl}/trainingprograms?show_subscribed=true`, { headers, signal })
      // ]);

      // const allPrograms = await allProgramsRes.json();
      // setAllTrainingPrograms(allPrograms);

      // REMOVE THIS AND UNCOMMENT ABOVE IF ALL PROGRAMS NEEDED
      const subscribedRes = await fetch(
        `${apiBaseUrl}/trainingprograms?show_subscribed=true`,
        { headers, signal }
      );

      const subscribedPrograms = await subscribedRes.json();
      if (subscribedPrograms.length > 0) {
        setTrainingProgram(subscribedPrograms[0]);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Error fetching auth data:", error);
      }
    }
  };

  // 2. Fetch User & Programs when Token/URL exists
  useEffect(() => {
    fetchUser();
  }, [authToken, apiBaseUrl, saveAuthToken]);

  return {
    authToken,
    saveAuthToken,
    loggedInUser,
    trainingProgram,
    allTrainingPrograms,
    fetchUser
  };
}
